/**
 * Limelight__ResiduePositions_n_c_Constants.ts
 */


export type Limelight__ResiduePosition__n__Type = "n"

export type Limelight__ResiduePosition__c__Type = "c"


/**
 * String Constants for Residue Positions of 'n' and 'c'
 */
export const Limelight__ResiduePositions_n_c_Constants: {
    readonly RESIDUE_POSITION__VALUE__N: Limelight__ResiduePosition__n__Type
    readonly RESIDUE_POSITION__VALUE__C: Limelight__ResiduePosition__c__Type
} = {

    RESIDUE_POSITION__VALUE__N: "n",
    RESIDUE_POSITION__VALUE__C: "c"
} as const


